import React from "react";
import {Link } from "react-router-dom";

import './About.css';

const aboutTopics = [
  {
    "name" : "Personal Background and Experience",
    "id": "engineering-journey",
  },
  {
    "name" : "Things I Have Built and Links",
    "id": "portfolio"
  },
];


function About() {
  return (
    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
      {aboutTopics.map(({ name, id }) => (
        <div key={id}>
          <Link  id="about-links" className="dropdown-item" to={`/${id}`}>
            {name}
          </Link>
        </div>
        ))}
    </div>
  )
}

export default About;
